import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6e8f900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-5" }
const _hoisted_2 = { class: "card main-table-container card-primary card-outline" }
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Roles - asociar permisos")
], -1))
const _hoisted_7 = { class: "p-0" }
const _hoisted_8 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-sort": "ascending",
      "aria-label": "Rendering engine: activate to sort column descending"
    }, " Rol "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Platform(s): activate to sort column ascending"
    })
  ])
], -1))
const _hoisted_13 = { class: "position-relative" }
const _hoisted_14 = {
  key: 0,
  class: "odd"
}
const _hoisted_15 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_16 = ["readonly"]
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "fas fa-check"
}
const _hoisted_21 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "dtr-control sorting_1",
  tabindex: "0",
  colspan: "100%"
}, /*#__PURE__*/_toDisplayString(`No hay registros`), -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-12 col-sm-6 px-4" }
const _hoisted_28 = { class: "rol-select" }
const _hoisted_29 = { class: "form-group col" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Aplicación", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "SELECCIONA UNA APLICACIÓN", -1))
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "col px-4" }
const _hoisted_34 = { class: "rol-select" }
const _hoisted_35 = { class: "form-group col" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Permisos", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "SELECCIONA UN PERMISO", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "card mt-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Permisos seleccionados")
], -1))
const _hoisted_43 = { class: "card-body p-0" }
const _hoisted_44 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-sm-12" }
const _hoisted_47 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-sort": "ascending",
      "aria-label": "Rendering engine: activate to sort column descending"
    }, " Nombre "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting",
      tabindex: "0",
      "aria-controls": "example1",
      rowspan: "1",
      colspan: "1",
      "aria-label": "Platform(s): activate to sort column ascending"
    })
  ])
], -1))
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  class: "dtr-control sorting_1",
  tabindex: "0"
}
const _hoisted_51 = { class: "text-center" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1",
    tabindex: "0",
    colspan: "100%"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "card-footer text-center" }

export function render(_ctx, _cache) {
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isBtnLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("tbody", _hoisted_13, [
                  (_ctx.roles)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                        _createElementVNode("td", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            readonly: !_ctx.editMode,
                            class: _normalizeClass({'form-control-plaintext': !_ctx.editMode,  'form-control': _ctx.editMode ,'is-invalid': _ctx.v$.roleName.$error, 'is-valid': !_ctx.v$.roleName.$error }),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.v$.roleName.$model) = $event))
                          }, null, 10, _hoisted_16), [
                            [_vModelText, _ctx.v$.roleName.$model]
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.roleName.$errors, (error) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "error invalid-feedback",
                              key: error.$uid
                            }, _toDisplayString(error.$message), 1))
                          }), 128))
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          (!_ctx.editMode && _ctx.isValidPermission('SEGURIDAD.EDITAR_ROLES'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-outline-primary",
                                onClick: _cache[1] || (_cache[1] = $event => (_ctx.editRole()))
                              }, _hoisted_19))
                            : _createCommentVNode("", true),
                          (_ctx.editMode)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "btn btn-outline-success",
                                onClick: _cache[2] || (_cache[2] = $event => (_ctx.updateRole()))
                              }, [
                                (!_ctx.isBtnLoading)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                  : _createCommentVNode("", true),
                                (_ctx.isBtnLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("tr", _hoisted_22, _hoisted_24))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_pagination, {
              modelValue: _ctx.page,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.page) = $event)),
              records: _ctx.records,
              "per-page": _ctx.perPage,
              onPaginate: _ctx.getResults
            }, null, 8, ["modelValue", "records", "per-page", "onPaginate"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("select", {
                class: "form-control mr-sm-2",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.applicationId) = $event)),
                onChange: _cache[5] || (_cache[5] = $event => (_ctx.getPermissionList()))
              }, [
                _hoisted_31,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applications, (application) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: application.id
                  }, _toDisplayString(application.name), 9, _hoisted_32))
                }), 256))
              ], 544), [
                [_vModelSelect, _ctx.applicationId]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.permission) = $event))
              }, [
                _hoisted_37,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissions, (item, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: item,
                    key: index
                  }, _toDisplayString(item.name), 9, _hoisted_38))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.permission]
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success add-rol-btn ml-2",
              onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.addPermisison && _ctx.addPermisison(...args)))
            }, _hoisted_40)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("table", _hoisted_47, [
                  _hoisted_48,
                  (_ctx.selectedPermissions && _ctx.selectedPermissions.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_49, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPermissions, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "odd",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_50, _toDisplayString(item.name), 1),
                            _createElementVNode("td", _hoisted_51, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger ml-2",
                                onClick: $event => (_ctx.removePermission(index))
                              }, _hoisted_54, 8, _hoisted_52)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_55, _hoisted_57))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        (_ctx.isValidPermission('SEGURIDAD.ASOCIAR_PERMISOS_ROL'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-success",
              onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.saveAsociation && _ctx.saveAsociation(...args)))
            }, " Guardar "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger ml-3",
          onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.goToRolesList && _ctx.goToRolesList(...args)))
        }, " Cancelar ")
      ])
    ])
  ]))
}